// @flow
import { Map, fromJS } from "immutable";
import moment from "moment";

export const readingsSelector = (state: Map<string, any>) => {
  const readings = state.getIn(["usage", "readings"]).map(r => {
    r = r.set('dateString', moment.utc(r.get('readAtUnix')).format('YYYY-MM-DD HH:mm'))
    return r

  })
  return fromJS(readings);
}

export const btuMeterReadingsSelector = (state: Map<string, any>) => {
  const readings = state.getIn(["usage", "btuMeterReadings"]).map(r => {
    r = r.set('dateString', moment.utc(r.get('readAtUnix')).format('YYYY-MM-DD HH:mm'))
    return r
  }).sortBy((r) => r.get('addressId'))
  return fromJS(readings);
}

export const usageErrorSelector = (state: Map<string, any>) => state.getIn(["usage", "error"])



// WEBPACK FOOTER //
// ./src/features/usage/store/usageSelectors.js